import { Divider, ListItemButton, ListItemText } from "@mui/material";

import { MenuNodeType } from "components/Menu/model";
import { useAutoFocus } from "hooks/useAutoFocus";
import { useAvoTracking } from "hooks/useAvoTracking";

import { sharedStyles } from "../shared.styles";

import { menuLinkNodeStyles as styles } from "./MenuLinkNode.styles";

export const MenuLinkNode = ({
  containerLinkText,
  expansionLinkText,
  focus,
  node,
}: {
  containerLinkText?: string;
  expansionLinkText?: string;
  focus: boolean;
  node: MenuNodeType.Link;
}) => {
  const { trackMenuClick } = useAvoTracking();
  const isTopLevelLink = node.nodeType === "topLevelLink";
  const isLinkUnderExpansionNode = !!expansionLinkText;
  const listItemButtonRef = useAutoFocus<HTMLAnchorElement>(focus);

  return (
    <>
      <ListItemButton
        ref={listItemButtonRef}
        component="a"
        css={styles.link}
        href={node.href}
        {...(node.newTab ? { target: "_blank" } : {})}
        onClick={(e) => {
          trackMenuClick({
            expansionLinkText,
            containerLinkText,
            name: node.analyticsTag,
            redirectLinkProps: {
              mouseEventHandler: e,
              redirectUrl: node.href,
              newTab: node.newTab,
            },
          });
        }}
      >
        <ListItemText
          css={[
            node.highlight && styles.highlightedNodeStyles,
            isLinkUnderExpansionNode
              ? styles.secondLevelNodeText
              : sharedStyles.listItemHeading,
          ]}
        >
          {node.titleKey}
        </ListItemText>
      </ListItemButton>
      {isTopLevelLink && (
        <Divider
          data-testid="menu-link-node-divider"
          css={!node.fullWidthDivider && styles.dividerMargins}
        />
      )}
    </>
  );
};
